export default __webpack_public_path__ + "static/media/WhatMakesUsSpecial.4d677acd.svg";